<div class="form-group d-flex flex-row align-items-center  mb-0">
    <input type="text" class="form-control"  name="value" [ngModel]="value" (ngModelChange)="onValueChange($event)">
</div>
